import { Component, ChangeDetectionStrategy } from '@angular/core';

import { AppsyncStatusBaseComponent } from '@ups/xplat/features';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-appsync-status',
  templateUrl: 'appsync-status.component.html',
  standalone: false,
})
export class AppsyncStatusComponent extends AppsyncStatusBaseComponent {
  constructor() {
    super();
  }
}
